window.okeReviewsWidgetOnInit = function () {
  // Move Reviews Aggregate above Navbar
  const reviewsAggregate = document.querySelector('.okeReviews-reviewsWidget-reviewsAggregate' );
  const customAggregateHolder = document.querySelector('#okeReviews-aggregateHolder');
  if (reviewsAggregate && customAggregateHolder) {
    customAggregateHolder.insertAdjacentElement('afterbegin', reviewsAggregate);
  }

  // Move WAR Button next to widget dropdown
  const warButton = document.querySelector('.okeReviews-reviewsWidget-header');
  const widgetDropdown = document.querySelector('.okeReviews-reviewsAggregate-side');
  if (warButton && widgetDropdown) {
    widgetDropdown.insertAdjacentElement('beforeend', warButton);
  }

  // Setup Mutation Observer for individual reviews
  const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
  if (reviewMain) {
    const callback = function (mutationList) {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach((n) => setupIndividualReview(n));
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(reviewMain, { childList: true });

    const reviews = document.querySelectorAll('.okeReviews-reviews-review');
    reviews.forEach((n) => setupIndividualReview(n));
  }
};

function setupIndividualReview(reviewElement) {
  formatDateForElement(reviewElement);
}

window.okeReviewsQandaOnInit = function () {
  const questionMain = document.querySelector('.js-okeReviews-questions-main');
  if (questionMain) {
    const callback = function (mutationList) {
      for (const mutation of mutationList) {
        mutation.addedNodes.forEach((n) => formatDateForElement(n));
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(questionMain, { childList: true });

    const questions = document.querySelectorAll('.okeReviews-question');
    questions.forEach((n) => formatDateForElement(n));
  }
};

// Change relative time format into format: MM/DD/YYYY
function formatDateForElement(nodeElement) {
  if (nodeElement) {
    const reviewDates = nodeElement.querySelectorAll('[data-oke-reviews-date]');
    for (const reviewDate of reviewDates) {
      const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
      const date = new Date(dateIsoString);
      const localeDate = `${
        date.getMonth() + 1
      }/${date.getDate()}/${date.getFullYear()}`;
      reviewDate.innerText = localeDate;
    }
  }
}
